import { createSlice } from '@reduxjs/toolkit'

import { fetchPrices_aggregated } from '../requests/thunks'
import * as DynamakerContract from '../../integration/DynamakerContract'

interface ConfigResultState {
  bom: DynamakerContract.ConfigResult['bom']
  meta: DynamakerContract.ConfigResult['meta']
  props: DynamakerContract.ConfigResult['props']
  items: DynamakerContract.ConfigResult['items']
  _latestPendingRequestId: string
}

const initialState: ConfigResultState = {
  bom: null, // [] -- bom in redux store is never used by the app itself, only saved to make debugging easier
  meta: null,
  props: null,
  items: null,
  _latestPendingRequestId: '',
} as any

const configResultSlice = createSlice({
  name: 'configResult',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrices_aggregated.pending, (state, action) => {
        state._latestPendingRequestId = action.meta.requestId
      })
      .addCase(fetchPrices_aggregated.fulfilled, (state, action) => {
        if (state._latestPendingRequestId === action.meta.requestId) {
          const {
            configResult: { bom, meta, props, items },
          } = action.payload

          state.bom = bom
          state.meta = meta
          state.props = props
          state.items = items
        } else if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
          console.log(
            "mok-context-spa in dev/test env: fetchPrices_aggregated was fulfilled for deprecated DM 'configuration-update' event -- payload is ignored."
          )
        }
      })
      .addCase(fetchPrices_aggregated.rejected, (state: any, action) => { // TODO
        if (state._latestPendingRequestId === action.meta.requestId) {
          // TODO fix
          state.errors = null
          state.articles = null
          state.summary = null
        } else if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
          console.log(
            "mok-context-spa in dev/test env: fetchPrices_aggregated was rejected for deprecated DM 'configuration-update' event."
          )
        }
      })
  },
})

export default configResultSlice.reducer
